import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault();
  window.__apiccoliPassiInstallPrompt = event;
  window.dispatchEvent(new Event("apiccolipassi-install-ready"));
});

window.addEventListener("appinstalled", () => {
  window.__apiccoliPassiInstallPrompt = null;
  window.dispatchEvent(new Event("apiccolipassi-install-complete"));
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  navigator.serviceWorker.register("/service-worker.js?v=6", {
    scope: "/",
    updateViaCache: "none",
  }).catch(() => {});
}
